(function () {
  'use strict';

  function parseList(str) {
    if (!str || typeof str !== 'string') return [];
    var s = str.trim();
    if (!s) return [];
    return s.split(',').map(function (item) { return item.trim().toLowerCase(); }).filter(Boolean);
  }

  function blockContainsValue(blockData, selectedValue) {
    if (!selectedValue) return true;
    var search = (selectedValue + '').trim().toLowerCase();
    var list = parseList(blockData);
    return list.some(function (item) {
      return item === search || item.indexOf(search) !== -1 || search.indexOf(item) !== -1;
    });
  }

  function init() {
    var forms = document.querySelectorAll('.events-program [data-events-filter-form]');
    for (var f = 0; f < forms.length; f++) {
      var form = forms[f];
      var program = form.closest('.events-program');
      if (!program) continue;
      var results = program.querySelector('[data-events-results]');
      var blocks = program.querySelectorAll('.event-block[data-event-block]');
      var nazioneSelect = form.querySelector('[data-filter-nazione]');
      var capInput = form.querySelector('[data-filter-cap]');
      var disciplinaSelect = form.querySelector('[data-filter-disciplina]');
      var modelloSelect = form.querySelector('[data-filter-modello]');

      function updateVisibility() {
        var nazione = (nazioneSelect && nazioneSelect.value) ? nazioneSelect.value.trim().toLowerCase() : '';
        var cap = (capInput && capInput.value) ? capInput.value.trim() : '';
        var disciplinaVal = (disciplinaSelect && disciplinaSelect.value) ? disciplinaSelect.value.trim().toLowerCase() : '';
        var isDisciplinaSelect = !disciplinaVal || disciplinaVal === 'seleziona' || disciplinaVal === 'select';
        var modelloVal = (modelloSelect && modelloSelect.value) ? modelloSelect.value.trim().toLowerCase() : '';
        var isModelloSelect = !modelloVal || modelloVal === 'seleziona' || modelloVal === 'select';

        var visibleCount = 0;
        for (var i = 0; i < blocks.length; i++) {
          var block = blocks[i];
          var blockNazione = (block.getAttribute('data-nazione') || '').trim().toLowerCase();
          var blockCap = (block.getAttribute('data-cap') || '').trim();
          var blockCapLower = blockCap.toLowerCase();
          var capLower = cap.toLowerCase();
          var blockTestBikes = (block.getAttribute('data-test-bikes') || '').trim();
          var blockModelli = (block.getAttribute('data-modelli') || '').trim();

          var matchNazione = !nazione || blockNazione === nazione;
          var matchCap = !cap || blockCapLower === capLower || (blockCap && blockCapLower.indexOf(capLower) !== -1);
          var matchDisciplina = isDisciplinaSelect || blockContainsValue(blockTestBikes, disciplinaVal);
          var matchModello = isModelloSelect || blockContainsValue(blockModelli, modelloVal);

          var show = matchNazione && matchCap && matchDisciplina && matchModello;
          block.setAttribute('data-hidden', show ? 'false' : 'true');
          block.style.display = show ? '' : 'none';
          if (show) visibleCount++;
        }

        for (var k = 0; k < blocks.length; k++) {
          blocks[k].classList.remove('event-block--no-border-bottom');
        }
        var lastVisible = null;
        for (var idx = blocks.length - 1; idx >= 0; idx--) {
          if (blocks[idx].getAttribute('data-hidden') === 'false') {
            lastVisible = blocks[idx];
            break;
          }
        }
        if (lastVisible) lastVisible.classList.add('event-block--no-border-bottom');

        if (results) {
          results.setAttribute('data-has-visible', visibleCount > 0 ? '1' : '0');
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var nazioneVal = (nazioneSelect && nazioneSelect.value) ? nazioneSelect.value.trim() : '';
        var capVal = (capInput && capInput.value) ? capInput.value.trim() : '';
        var disciplinaVal = (disciplinaSelect && disciplinaSelect.value) ? disciplinaSelect.value.trim() : '';
        var modelloVal = (modelloSelect && modelloSelect.value) ? modelloSelect.value.trim() : '';
        var allEmpty = !nazioneVal && !capVal && !disciplinaVal && !modelloVal;
        var errorEl = form.querySelector('[data-events-form-error]');
        var errorMessage = form.getAttribute('data-error-empty') || 'Compilare almeno un campo per la ricerca.';
        if (errorEl) {
          if (allEmpty) {
            errorEl.textContent = errorMessage;
            errorEl.removeAttribute('hidden');
            return;
          }
          errorEl.setAttribute('hidden', '');
        }
        updateVisibility();
      });

      // All'atterraggio: mostra tutti gli eventi e togli bordo all'ultimo
      for (var j = 0; j < blocks.length; j++) {
        blocks[j].setAttribute('data-hidden', 'false');
        blocks[j].style.display = '';
        blocks[j].classList.remove('event-block--no-border-bottom');
      }
      if (blocks.length > 0) {
        blocks[blocks.length - 1].classList.add('event-block--no-border-bottom');
      }
      if (results && blocks.length > 0) {
        results.setAttribute('data-has-visible', '1');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
